import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import TailwindLayout from 'TailwindcssComponents/TailwindLayout';
import TopBar from 'TailwindcssComponents/TopBar';
import FooterTailwind from 'TailwindcssComponents/Footer';

export default function EditEventZone() {
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const bearerToken = localStorage.getItem('token');
    const navigate = useNavigate();
    const { id } = useParams();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [zoneData, setZoneData] = useState([]);

    useEffect(() => {
        const fetchZoneData = async () => {
            try {
                const response = await axios.get(`${apiUrl}event-service/venue-zone/${id}`);
                if (response.data?.success) {
                    const zone = response.data?.data;
                    editZone.setValues({
                        name: zone.name,
                        capacity: zone.capacity,
                        isSeat: zone.isSeat,
                    });
                    setZoneData(zone);
                } else throw new Error(response.data?.message || 'Error in fetching venues');
            } catch (error) {
                console.error('Error fetching zone data:', error.message);
            }
        };

        fetchZoneData();
    }, [id]);

    const editZone = useFormik({
        initialValues: {
            name: '',
            capacity: '',
            isSeat: false,
        },
        validationSchema: Yup.object({
            name: Yup.string().required('Required'),
            capacity: Yup.number().required('Required'),
            isSeat: Yup.boolean(),
        }),
        onSubmit: async (values) => {
            setIsSubmitting(true);
            try {
                const { name, ...restValues } = values;
                const payload = {
                    ...(zoneData.name !== name ? { name } : {}),
                    ...restValues,
                };
                const response = await axios.put(`${apiUrl}event-service/venue-zone/${id}`, payload, {
                    headers: {
                        'Authorization': `Bearer ${bearerToken}`,
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'accept': 'application/json',
                    },
                });

                if (!response.data.success) {
                    throw new Error(response.data.message);
                }

                toast.success('Zone has been successfully updated!');
                setTimeout(() => {
                    navigate(-1);
                    setIsSubmitting(false);
                }, 1000);

            } catch (error) {
                setIsSubmitting(false);
                console.error('Error inserting data:', error.response?.data.message || error.message);
                toast.error(`Error: ${error.response?.data.message || error.message}`);
            }
        },
    });

    return (
        <TailwindLayout>
            <TopBar />
            <div className="max-w-7xl mx-auto p-12 sm:p-12 lg:p-12 mb-8">
                <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                    <form onSubmit={editZone.handleSubmit} className="p-6 space-y-6">
                        <h2 className="text-xl font-semibold text-gray-900 mb-4">Edit Zone</h2>
                        <div>
                            <label className="block text-sm font-medium mb-2">
                                Name <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="text"
                                name="name"
                                value={editZone.values.name}
                                onChange={editZone.handleChange}
                                onBlur={editZone.handleBlur}
                                placeholder="zone name"
                                className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-300" />
                        </div>
                        <div>
                            <label className="block text-sm font-medium mb-2">
                                Capacity <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="number"
                                name="capacity"
                                value={editZone.values.capacity}
                                onChange={editZone.handleChange}
                                onBlur={editZone.handleBlur}
                                min={1}
                                placeholder="e.g 100"
                                className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-300" />
                        </div>
                        <div className="flex gap-6 mt-4">
                            <p>Seat Setup</p>
                            <div className="flex gap-6">
                                {[{ label: "Yes", value: "true" }, { label: "No", value: "false" }].map((option) => (
                                    <label key={option.value} className="flex items-center space-x-3 text-gray-700">
                                        <input
                                            type="radio"
                                            name="isSeat"
                                            value={option.value}
                                            onChange={(e) => {
                                                editZone.setFieldValue("isSeat", e.target.value);
                                                if (e.target.value === "false") {
                                                    editZone.setFieldValue("totalRows", "");
                                                    editZone.setFieldValue("totalSeatsPerRows", "");
                                                }
                                            }}
                                            checked={String(editZone.values.isSeat) === option.value}
                                            className="form-radio h-5 w-5 text-blue-600"
                                        />
                                        <span>{option.label}</span>
                                    </label>
                                ))}
                            </div>
                        </div>

                        {/* Submit Button */}
                        <div className="mt-6 flex items-center">
                            <button
                                type="submit"
                                disabled={isSubmitting}
                                className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 disabled:opacity-50"
                            >
                                {isSubmitting ? 'Saving...' : 'Save'}
                            </button>
                            {isSubmitting && (
                                <span className="ml-2 text-gray-600">Saving....</span>
                            )}
                        </div>
                    </form>
                </div>
            </div>
            <FooterTailwind />
            <ToastContainer
                position="bottom-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </TailwindLayout>
    )
}